// @ts-nocheck
import React from 'react'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { resetPasswordConfirm } from 'ducks/auth'
import { useControlledForm } from 'hooks'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

const useNewPasswordMutations = () => {
  const dispatch = useDispatch()

  const handlePasswordChange = React.useCallback(
    ({ password, token, uid }) => {
      dispatch(resetPasswordConfirm({ password, token, uid }))
    },
    [dispatch],
  )

  return { handlePasswordChange }
}

export const useNewPasswordForm = state => {
  const { token, uid } = state

  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const { handlePasswordChange } = useNewPasswordMutations()

  const handleFormData = React.useCallback(
    data => {
      handlePasswordChange({ ...data, token, uid })
    },
    [token, uid, handlePasswordChange],
  )

  const { control, formState, handleFormSubmit } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  return {
    state: { control, formState },
    handlers: { handleFormSubmit },
  }
}